import api from "@modules/api/api";
import userQueryKeys from "@modules/user/userQueryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import PurchaseQueryKeys from "@modules/purchase/purchaseQueryKeys";

type RequestBody = {
  tradeInToken?: string;
  source?: string;
  dealId?: string;
};

export type ChangeUserTenantResponse = {
  requiresLogin: boolean;
};

const performPost = async (
  body: RequestBody
): Promise<ChangeUserTenantResponse> => {
  return api.post(`api/purchases/change-user-tenants`, {
    json: body,
  });
};

export default function useChangeUserTenantMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: performPost,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userQueryKeys.user() });
      queryClient.invalidateQueries({ queryKey: PurchaseQueryKeys.all });
    },
  });
}
